import { render, staticRenderFns } from "./CampaignInfoCard.vue?vue&type=template&id=f37c620e&scoped=true&"
import script from "./CampaignInfoCard.vue?vue&type=script&lang=js&"
export * from "./CampaignInfoCard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f37c620e",
  null
  
)

export default component.exports